import { sendRequest, unexpectedErrorMessage } from "../../../functions";

/**
 *
 * @param {*} form
 */
export function handleAdherentCodeChecking(form) {
    let adhesionTicketComp;

    // Get adhesion ticket component
    Object.entries(form.flattenComponents()).forEach((item, key) => {
        let component = item[1];
        if (component.component.hasOwnProperty('attributes') && component.component.attributes.hasOwnProperty('data-adhesion-ticket')) {
            adhesionTicketComp = component;
        }
    })

    if (adhesionTicketComp != undefined) {

        // On change check if adherent exists
        form.on("change", (modification) => {

            if (modification.changed.component.key != 'adhesionAlert' && modification.changed.component.attributes.hasOwnProperty('data-adhesion-ticket') == false
                && modification.changed.instance.hasOwnProperty('parent') && modification.changed.instance.parent.key == 'adhesion') {
                $('#adhesionAlert').removeClass('alert-danger alert-success').addClass('d-none');
            }

            if (modification.changed.component.key == 'adherent_code') {

                try {
                    let value = modification.changed.value;
                    $('#adhesionAlert').html('').addClass('d-none');
                    $('#adherentCode').attr("data-checked", false);
                    adhesionTicketComp.triggerChange()

                    if (value.length >= 6) {

                        sendRequest(route('frontend.event.participants.checkAdherentExists', eventSlug), "POST", {"adherent_code": value})
                        .done((response, status, xhr) => {
                            $('#adhesionAlert').html(response.message).removeClass('d-none alert-danger').addClass('alert-success');
                            if (xhr.status == 200) {
                                $('#adherentCode').attr("data-checked", true);
                                adhesionTicketComp.triggerChange() // trigger change event to show the adhesion ticket (check adhesion ticket component js conditional script)
                            }
                        })
                        .fail((response, status, xhr) => {
                            if (xhr.status == 500) {
                                console.log(response);
                                alert(unexpectedErrorMessage)
                                return;
                            }
                            $('#adhesionAlert').html(response.responseJSON.message).removeClass('d-none alert-success').addClass('alert-danger');
                            $('#adherentCode').attr("data-checked", false);
                            adhesionTicketComp.triggerChange() // trigger change event to show the adhesion ticket (check adhesion ticket component js conditional script)
                        })
                    }

                } catch(error) {
                    console.error('Error when checking adherent : ', error)
                    alert(unexpectedErrorMessage);
                }
            }
        });
    }
}

